// extracted by mini-css-extract-plugin
var _1 = "InvestmentRiskModalStyle-module__button___TavFO";
var _2 = "InvestmentRiskModalStyle-module__link____3VxN";
var _3 = "InvestmentRiskModalStyle-module__title___yRWQw";
export { _1 as "button", _2 as "link", _3 as "title" }
